/* eslint-disable indent */
/* eslint-disable camelcase */
import store from '../../store'
import { setTransitScores } from '../slices/criteriaSelection/transit'
import {
  TRANSIT_STOP_AMENITIES_VALUES,
  TRANSIT_STOP_AMENITIES,
  HIGH_CAPACITY_TRANSIT_FACILITY,
  HIGH_CAPACITY_TRANSIT_FACILITY_VALUES,
  HCT_AMENITIES_VALUES
} from '../constants/transit'
import { NO, YES } from '../constants/roadwayVariables'
import { NA } from '../constants/scores'

export function calculateTransitScore() {
  const { transit, roadwayVariables, modalTiers } = store.getState()
  const { Transit: TTier } = modalTiers
  const { high_capacity_transit } = roadwayVariables
  const {
    transit_stop_amenities,
    high_capacity_transit_facility,
    hct_amenities
  } = transit

  // If Transit Tier is 0 or NA , do not calculate score
  // Every score is NA
  if (TTier === 0) {
    for (const key of Object.keys(transit)) {
      store.dispatch(
        setTransitScores({
          field: key,
          value: NA
        })
      )
    }
    return
  }

  const allThreeExsist = transit_stop_amenities.filter((val) =>
    [
      TRANSIT_STOP_AMENITIES_VALUES[0],
      TRANSIT_STOP_AMENITIES_VALUES[1],
      TRANSIT_STOP_AMENITIES_VALUES[2]
    ].includes(val)
  )
  const allTwoExsist = transit_stop_amenities.filter((val) =>
    [
      TRANSIT_STOP_AMENITIES_VALUES[0],
      TRANSIT_STOP_AMENITIES_VALUES[1]
    ].includes(val)
  )
  const HCTScoreArr = Array(5)
  let HCTScore = 0

  // Calcualte TRANSIT STOP AMENITIES SCORE
  if (allThreeExsist.length === 3 && transit_stop_amenities.length >= 8) {
    store.dispatch(
      setTransitScores({ field: TRANSIT_STOP_AMENITIES, value: 1 })
    )
  } else if (allTwoExsist.length === 2 && transit_stop_amenities.length >= 5) {
    store.dispatch(
      setTransitScores({ field: TRANSIT_STOP_AMENITIES, value: 2 })
    )
  } else if (allTwoExsist.length === 2 && transit_stop_amenities.length >= 3) {
    store.dispatch(
      setTransitScores({ field: TRANSIT_STOP_AMENITIES, value: 3 })
    )
  } else {
    store.dispatch(
      setTransitScores({ field: TRANSIT_STOP_AMENITIES, value: 4 })
    )
  }
  // Calcualte TRANSIT STOP FACILITIES SCORE
  caculateHCTFacilityScore()

  function caculateHCTFacilityScore() {
    if (high_capacity_transit === NO) {
      store.dispatch(
        setTransitScores({
          field: HIGH_CAPACITY_TRANSIT_FACILITY,
          value: NA
        })
      )
      return
    } else if (high_capacity_transit === YES) {
      if (
        high_capacity_transit_facility ===
        HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[0]
      ) {
        HCTScoreArr[0] = hct_amenities.includes(HCT_AMENITIES_VALUES[6])
          ? -1
          : 0
        HCTScoreArr[1] = hct_amenities.includes(HCT_AMENITIES_VALUES[7])
          ? -1
          : 0
        HCTScoreArr[2] = hct_amenities.includes(HCT_AMENITIES_VALUES[8])
          ? -1
          : 0
        HCTScoreArr[3] = hct_amenities.includes(HCT_AMENITIES_VALUES[13])
          ? -1
          : 0
        HCTScoreArr[4] = 2
      } else if (
        high_capacity_transit_facility ===
        HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[1]
      ) {
        HCTScoreArr[0] = hct_amenities.includes(HCT_AMENITIES_VALUES[0])
          ? -1
          : 0
        HCTScoreArr[1] = hct_amenities.includes(HCT_AMENITIES_VALUES[1])
          ? -1
          : 0
        HCTScoreArr[2] = hct_amenities.includes(HCT_AMENITIES_VALUES[2])
          ? -1
          : 0
        HCTScoreArr[3] = 0
        HCTScoreArr[4] = 3
      } else if (
        high_capacity_transit_facility ===
        HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[2]
      ) {
        HCTScoreArr[0] = hct_amenities.includes(HCT_AMENITIES_VALUES[3])
          ? -1
          : 0
        HCTScoreArr[1] = hct_amenities.includes(HCT_AMENITIES_VALUES[4])
          ? -1
          : 0
        HCTScoreArr[2] = hct_amenities.includes(HCT_AMENITIES_VALUES[5])
          ? -1
          : 0
        HCTScoreArr[3] = hct_amenities.includes(HCT_AMENITIES_VALUES[12])
          ? -1
          : 0
        HCTScoreArr[4] = 3
      } else if (
        high_capacity_transit_facility ===
        HIGH_CAPACITY_TRANSIT_FACILITY_VALUES[3]
      ) {
        HCTScoreArr[0] = hct_amenities.includes(HCT_AMENITIES_VALUES[9])
          ? -1
          : 0
        HCTScoreArr[1] = hct_amenities.includes(HCT_AMENITIES_VALUES[10])
          ? -1
          : 0
        HCTScoreArr[2] = hct_amenities.includes(HCT_AMENITIES_VALUES[11])
          ? -1
          : 0
        HCTScoreArr[3] = hct_amenities.includes(HCT_AMENITIES_VALUES[14])
          ? -1
          : 0
        HCTScoreArr[4] = 4
      }
      // Calcualte HCT score. each amenity improves base facility score by 1
      HCTScore = Math.abs(
        HCTScoreArr.slice(0, 4).reduce((a, sum) => a + sum, 0)
      )
      HCTScore = HCTScoreArr[4] - HCTScore

      // 'if HCT is 'No' or if HCT values are negative, these revert to 1
      if (
        HCTScore < 1 &&
        high_capacity_transit_facility === '' &&
        high_capacity_transit === YES
      ) {
        HCTScore = 'N/A'
      } else if (HCTScore < 1) {
        HCTScore = 1
      }
    }

    // If Yes , dispatch the final high capacity transit score
    store.dispatch(
      setTransitScores({
        field: HIGH_CAPACITY_TRANSIT_FACILITY,
        value: HCTScore
      })
    )
  }
}
